{
	"totalProductsGwp": "Total products GWP",
	"totalAllocatedCarbonReductions": "Total allocated carbon reductions",
	"totalEacEquivalence": "Total EAC equivalence",
	"fetchError": "Failed to load KPI statistics",
	"downloadCsvTitle": "Download CSV",
	"downloadError": "Failed to download CSV",
	"flagAllFiltered": "Flag all filtered transactions"
}
